<div class="rcs-sms-builder">
  <div class="card">
    <div class="card-header">SMS Message</div>
    <div class="form-group">
      <label for="smsMessage">Message Text</label>
      <textarea
        id="smsMessage"
        [(ngModel)]="smsText"
        (ngModelChange)="onTextChange()"
        (blur)="validateText()"
        [class.error]="textError"
        placeholder="Enter your SMS message here..."
        rows="6">
      </textarea>
      <small class="help-text" *ngIf="!textError">Enter the text content for your SMS message. SMS messages support up to 160 characters per message.</small>
      <small class="error-text" *ngIf="textError">{{ textError }}</small>
    </div>
    <div class="message-info">
      <p><strong>Character Count:</strong> {{ smsText.length }}</p>
      <p class="info-note" [class.warning]="smsText.length > 160">
        <span *ngIf="smsText.length <= 160">SMS messages support up to 160 characters (1 message).</span>
        <span *ngIf="smsText.length > 160 && smsText.length <= 320">This message will be split into {{ Math.ceil(smsText.length / 160) }} SMS messages.</span>
        <span *ngIf="smsText.length > 320">Long messages may be converted to MMS format.</span>
      </p>
    </div>
  </div>
</div>

